import script from "./StepFour.vue?vue&type=script&setup=true&lang=js"
export * from "./StepFour.vue?vue&type=script&setup=true&lang=js"

import "./StepFour.vue?vue&type=style&index=0&id=13a4ff46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13a4ff46"]])

export default __exports__